import React from 'react';
import { Radio } from 'antd';

const UNIT_CHOICES = ['#', '%'];

function UnitToggle({ selectedUnit, onChange, disabled = false }) {

  const handleChange = (e) => {
    onChange(e.target.value);
  }

  return (
    <Radio.Group
      size="middle"
      options={UNIT_CHOICES}
      onChange={handleChange}
      value={selectedUnit}
      disabled={disabled}
      optionType="button"
    />
  );
}

export default UnitToggle;
